<template>
  <div>
    <main class="mb-5">
      <section class="mb-3 doctor-item">
        <div class="d-flex p-3">
          <div class="doctor-item__avatar">
            <img
              :src="avatar"
              alt=""
              width="144"
              height="144"
              class="img-fluid rounded-circle">
          </div>
          <div class="pl-3 doctor-item__content">
            <h3 class="my-0">{{ data.name }} <small class="text-muted">{{ data.title }}</small></h3>
            <!-- <div class="pt-1">
              <small>问诊费用: </small>
              <small style="color: orange;">{{ current_price + unit }}</small>
            </div> -->
          </div>
        </div>
      </section>
      <van-cell-group class="doctor-cell">
        <van-cell
          :label="data.experience"
          title="医生简介" />
        <van-cell
          :label="data.good_at"
          title="擅长" />
        <van-cell
          :label="data.honor"
          title="荣誉" />
          <!-- <van-cell
          :label="(price / 100).toFixed(2) + unit"
          title="问诊费用">
        </van-cell> -->
      </van-cell-group>
      <div class="p-3">
        <van-button
          type="primary"
          size="large"
          @click="handleOnSubmit">问医生</van-button>
      </div>
    </main>
  </div>
</template>

<script>
import { apiURL } from '@/libs/const';

export default {
  name: 'DoctorDetail',
  data() {
    return {
      data: {
        id: 0,
        name: '',
        title: '',
        good_at: '',
        honor: '',
        experience: '',
      },
      price: 0,
      current_price: 0,
      unit: 0,
    };
  },
  computed: {
    avatar() {
      const { id } = this.data;
      return `${apiURL}/cloud-film-api/webapi/professional/get-doctor-avatar/${id}`;
    },
  },
  activated() {
    this.handleLoad();
  },
  methods: {
    async handleLoad() {
      const { id } = this.$route.params;
      this.data = await this.$http.get(`/cloud-film-api/webapi/professional/get-doctor/${id}`);
      // const response = await this.$http.get('/cloud-film-api/webapi/order/find-price', {
      //   type: sessionStorage.getItem('report-type'),
      //   doctorId: this.data.id,
      // });
      // this.price = response.price_yuan;
      // this.current_price = response.current_price_yuan;
      // this.unit = response.unit;
    },
    async handleOnSubmit() {
      // sessionStorage.setItem('doctor_price', this.price);
      // sessionStorage.setItem('doctor_current_price', this.current_price);
      const response = await this.$http.get('/cloud-film-api/webapi/order/state');
      if (response.status_code === '0') {
        sessionStorage.setItem('doctor_name', this.data.name);
        sessionStorage.setItem('doctor_title', this.data.title);
        this.$router.push({ name: 'select-film', params: this.data.id });
      } else {
        this.$toast.success(response.info);
      }
    },
  },
};
</script>

<style scoped>
.doctor-item {
  background-color: #fff;
}

.doctor-item__avatar {
  width: 48px;
  height: 48px;
}

.doctor-item__content {
  flex: 1;
  max-width: calc(100% - 64px);
  display: flex;
  align-items: center;
}

.doctor-cell >>> .van-cell__label {
  font-size: 0.875rem;
}

.price {
  background-color: #fff;
  line-height: 44px;
  padding-right: 12px;
  color: #f44;
  text-align: right;
}
</style>
